import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import DateField from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import moment from 'moment';
import { defaultFormat, monthYear } from 'Consts/DateFormats';

export default fr.metaOverride({ base: BaseOverride }).typeOverride('date', {
  _customProps: {
    openTo: 'year',
    views: ['year', 'month'],
    format: monthYear,
    placeholder: monthYear,
  },
  _component: () => DateField,
  _transformValue: () => v => {
    return moment.utc(v).format(defaultFormat);
  },
});
